"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var ArrowBackIos_1 = require("@material-ui/icons/ArrowBackIos");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var cache_1 = require("../../../common/graphql/cache");
var JourneySteps_1 = require("../../constants/JourneySteps");
var JourneyStepsRoutes_1 = require("../../enum/JourneyStepsRoutes");
var client_1 = require("@apollo/client");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var useUrlSearchParams_1 = require("../../../../common/hooks/useUrlSearchParams");
var RedirectOrigins_1 = require("../../enum/RedirectOrigins");
var useWidgetContext_1 = require("../../../../common/react/useWidgetContext");
var MyAccountRoutes_1 = require("../../enum/MyAccountRoutes");
var UrlParamTypes_1 = require("../../../../common/enum/UrlParamTypes");
var useCancelVehicleReservation_1 = require("../../hooks/mutations/useCancelVehicleReservation");
var useSalesEnablementCommunication_1 = require("../../../../gql/common/hooks/useSalesEnablementCommunication");
var useBackLink_1 = require("../../hooks/useBackLink");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var errorHandler_1 = require("../../../common/service/errorHandler");
var useCheckDealStatus_1 = require("../../../../../src/gql/checkout4/hooks/useCheckDealStatus");
var navigationStyles_1 = require("./navigationStyles");
var Navigation = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var location = react_router_dom_1.useLocation();
    var history = react_router_dom_1.useHistory();
    var searchParams = useUrlSearchParams_1.default();
    var myAccountUrl = useWidgetContext_1.default().configuration.myAccountUrl;
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    var activeJourney = client_1.useReactiveVar(cache_1.activeJourneyType);
    var selectedJourney = JourneySteps_1.Journeys.find(function (journey) { return journey.journeyType === activeJourney; });
    var deal = useCheckoutContext_1.default().deal;
    var configurationSourceUrl = react_1.useMemo(function () { var _a, _b; return (_b = (_a = deal) === null || _a === void 0 ? void 0 : _a.car) === null || _b === void 0 ? void 0 : _b.configurationSourceUrl; }, [deal]);
    var _j = useCancelVehicleReservation_1.useCancelVehicleReservation(), removeSoftLock = _j.removeSoftLock, loadingRemoveSoftLock = _j.loading;
    var isInConfirmationPage = useSalesEnablementCommunication_1.default().isInConfirmationPage;
    var isDisabledInSe = isInConfirmationPage(location);
    var getRedirectUrl = react_1.useCallback(function (path) {
        var queryString = Object.entries(searchParams).reduce(function (prev, _a) {
            var key = _a[0], value = _a[1];
            if (!key && !value && key === UrlParamTypes_1.UrlParamTypes.FROM) {
                return prev;
            }
            return "" + prev + (prev === '' ? '?' : '&') + (key === UrlParamTypes_1.UrlParamTypes.TOKEN ? 'dealId' : key) + "=" + value;
        }, '');
        return "" + myAccountUrl + path + queryString;
    }, [searchParams, myAccountUrl]);
    var _k = useBackLink_1.default(), backLinkUrl = _k.backLinkUrl, isOverride = _k.isOverride;
    var hideBackLink = ((_a = checkout4) === null || _a === void 0 ? void 0 : _a.hideBackLink) ||
        (((_b = checkout4) === null || _b === void 0 ? void 0 : _b.hideBackLinkWhenRedirectedFromMyAccount) &&
            Object.values(RedirectOrigins_1.RedirectOrigins).includes((_c = searchParams) === null || _c === void 0 ? void 0 : _c.from));
    var disableBackLink = ((_d = checkout4) === null || _d === void 0 ? void 0 : _d.disableBackLinkWhenRedirectedFromMyAccount) &&
        Object.values(RedirectOrigins_1.RedirectOrigins).includes((_e = searchParams) === null || _e === void 0 ? void 0 : _e.from);
    var handleRedirect = react_1.useCallback(function () {
        var _a, _b, _c, _d, _e;
        switch ((_a = searchParams) === null || _a === void 0 ? void 0 : _a.from) {
            case RedirectOrigins_1.RedirectOrigins.ENQUIRY:
                window.location.href = getRedirectUrl(MyAccountRoutes_1.MyAccountRoutes.MYACCOUNT_ENQUIRY);
                break;
            case RedirectOrigins_1.RedirectOrigins.ORDERS:
                window.location.href = getRedirectUrl(MyAccountRoutes_1.MyAccountRoutes.MYACCOUNT_ORDERS);
                break;
            case RedirectOrigins_1.RedirectOrigins.RESERVATIONS:
                window.location.href = getRedirectUrl(MyAccountRoutes_1.MyAccountRoutes.MYACCOUNT_RESERVATIONS);
                break;
            case RedirectOrigins_1.RedirectOrigins.SAVED_CARS:
                window.location.href = getRedirectUrl(MyAccountRoutes_1.MyAccountRoutes.MYACCOUNT_SAVED_CARS);
                break;
            case RedirectOrigins_1.RedirectOrigins.MY_ACCOUNT:
                history.goBack();
                break;
            default:
                var backUrl = !!((_c = (_b = deal) === null || _b === void 0 ? void 0 : _b.car) === null || _c === void 0 ? void 0 : _c.stock)
                    ? configurationSourceUrl + "?" + UrlParamTypes_1.UrlParamTypes.REVERT_TO_BYO + "=" + ((_e = (_d = deal) === null || _d === void 0 ? void 0 : _d.car) === null || _e === void 0 ? void 0 : _e.code)
                    : configurationSourceUrl;
                window.location.href = backUrl;
                break;
        }
    }, [(_f = searchParams) === null || _f === void 0 ? void 0 : _f.from, (_h = (_g = deal) === null || _g === void 0 ? void 0 : _g.car) === null || _h === void 0 ? void 0 : _h.stock]);
    var handleBackButton = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, removeSoftLock()];
                case 1:
                    _a.sent();
                    if (isOverride) {
                        window.location.href = backLinkUrl;
                        return [2 /*return*/];
                    }
                    handleRedirect();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    errorHandler_1.default.handleError(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [isOverride, backLinkUrl, deal, configurationSourceUrl, handleRedirect]);
    var headerTitle = react_1.useCallback(function () {
        var _a;
        switch (location.pathname) {
            case JourneyStepsRoutes_1.JourneyStepsRoutes.CONFIRMATION:
                if (activeJourney) {
                    return (_a = {},
                        _a[globalTypes_1.JourneyType.continue_in_dealership] = 'trans__checkout__confirmation_page__title_enquiry_journey',
                        _a[globalTypes_1.JourneyType.reserve_online] = 'trans__checkout__confirmation_page__title_reserve_journey',
                        _a[globalTypes_1.JourneyType.online_order] = 'trans__checkout__next_step__confirmation_page__order_journey_title',
                        _a)[activeJourney];
                }
                else {
                    return 'trans__checkout__next_step__confirmation_page_label';
                }
            case JourneyStepsRoutes_1.JourneyStepsRoutes.NEXT_STEPS:
                return 'trans__checkout__your_next_step_label';
            default:
                if (!!selectedJourney) {
                    return selectedJourney.title;
                }
                else {
                    return 'trans__checkout__your_next_step_label';
                }
        }
    }, [selectedJourney, location.pathname]);
    var storedIsDealExportValid = useCheckDealStatus_1.default().storedIsDealExportValid;
    var styles = navigationStyles_1.default();
    return (
    // dxp-id - added for widget integration
    <core_1.Grid container id="dxp-checkout-navigation" className={styles.root}>
      <core_1.Grid item xs={12} className={styles.wrapper}>
        {!hideBackLink && (<core_1.Box className={styles.backContainer}>
            <core_1.Chip classes={{
        outlined: styles.backButton,
        label: styles.backLabel,
        icon: styles.backIcon,
    }} variant="outlined" onClick={handleBackButton} icon={<ArrowBackIos_1.default />} label={<Translation_1.default id="trans__checkout__general__back_link"/>} data-test="checkout:navigation:backButton" disabled={loadingRemoveSoftLock || disableBackLink || isDisabledInSe || storedIsDealExportValid}/>
          </core_1.Box>)}
        <core_1.Box className={styles.headerContainer}>
          <core_1.Typography variant="body1" className={styles.headerTitle} data-test="checkout:navigation:header:title">
            <Translation_1.default id={headerTitle()}/>
          </core_1.Typography>
        </core_1.Box>
      </core_1.Grid>
    </core_1.Grid>);
};
exports.default = Navigation;
